import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';

export const useSetItemProceed = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ordersRecognitionApi.setItemProceed,
        onSuccess: async (res) => {
            if (res?.data?.status === 'success') {
                await queryClient.invalidateQueries({
                    queryKey: ordersRecognitionApi.getOrdersRecognitionListQueryOptions().queryKey,
                });
            }
        },
    });
};
